import {
  ActiveBriefCase,
  ActiveCompass,
  ActiveHome,
  AutoApply,
  Badminton,
  BarChartSquare,
  Bell,
  BriefCase,
  Cart,
  Compass,
  Download,
  Feedback,
  Home,
  Logout,
  ManageAlerts,
  Message,
  ProfileNew,
  ProfileNewActive,
  Search,
  Setting,
  SkillTest,
  Subsription,
} from "@monsterindia/global-ui-components";

export const rootPageName = "/career-services";
export const cookieName = `MSSOAT`;
export const brandLogoName = `foundit Logo`;
export const brandLogo = `//media.foundit.in/trex/public/theme_3/src/assets/images/header/companyLogo.svg`;

export const mobileBottomNav = (isLoggedIn: boolean) => {
  return [
    {
      name: `Home`,
      url: `/`,
      icon: Home,
      activeIcon: ActiveHome,
      isActive: false,
      target: `_self`,
    },
    {
      name: `Jobs`,
      url: isLoggedIn
        ? `/seeker/dashboard`
        : '/srp/results?query=""&quickApplyJobs=true',
      icon: BriefCase,
      activeIcon: ActiveBriefCase,
      isActive: false,
      target: `_self`,
    },
    {
      name: "Profile",
      url: "/seeker/profile",
      icon: ProfileNew as React.ReactNode,
      activeIcon: ProfileNewActive as React.ReactNode,
      isActive: true,
      target: "_self",
    },
    {
      name: `Services`,
      url: `/career-services`,
      icon: Compass,
      activeIcon: ActiveCompass,
      isActive: false,
      target: `_self`,
    },
  ];
};

export const cartData = (count: number | null, cartPath: string) => {
  return {
    href: cartPath,
    count,
    icon: <Cart width={24} height={24} />,
  };
};

export const accountList = () => [
  {
    name: `Manage Job Alert`,
    iconComponent: ManageAlerts,
    link: `/seeker/job-alert-list`,
  },
  {
    name: `Auto Apply`,
    iconComponent: AutoApply,
    link: `/seeker/dashboard?application_source=Organic&activeTab=applied`,
    addNewTag: true,
  },
  {
    name: `Profile Performance`,
    iconComponent: BarChartSquare,
    link: `/seeker/profile-performance`,
  },
  {
    name: `My Assessments`,
    iconComponent: SkillTest,
    link: `/skillyst/dashboard`,
  },
  {
    name: `My Subscriptions`,
    iconComponent: Subsription,
    link: `/web/en/my-subscriptions`,
  },
  {
    name: `Settings`,
    iconComponent: Setting,
    link: `/seeker/settings`,
  },
];

export const companyList = (mediaUrl: string | null) => [
  {
    name: "Badminton World Federation",
    iconComponent: Badminton,
    link: "/badminton",
    addNewTag: true,
  },
  {
    name: "Feedback",
    iconComponent: Feedback as React.ReactNode,
    link: "/account/feedback",
  },
  {
    name: "Download App",
    iconComponent: Download as React.ReactNode,
    imagesUrls: [
      {
        mediaUrl: `https://${mediaUrl}/public/core/images/appstore.svg`,
        appName: "App Store",
        link: "https://apps.apple.com/in/app/foundit-monster-job-search/id525775161",
      },
      {
        mediaUrl: `https://${mediaUrl}/public/core/images/playstore.svg`,
        appName: "Play Store",
        link: "https://play.google.com/store/apps/details?id=com.monsterindia.seeker.views&referrer=utm_source%3DWebsite%26utm_campaign%3DJobs-App",
      },
    ],
  },
  {
    name: "Logout",
    iconComponent: Logout as React.ReactNode,
    link: "/rio/sign-out",
  },
];

export const userIconsData = (
  notificationCount: number | null,
  cartCount: number | null,
  cartPath: string,
  kiwiUserId: number,
  site_map: string,
) => {
  return [
    ...(site_map === "rexmonster"
      ? [
          {
            href: `/v4/mychatpage?seekerId=${kiwiUserId}&platform=seeker`,
            visibleOnDesktop: false,
            icon: <Message width={24} height={24} />,
          },
        ]
      : []),
    {
      href: `/seeker/notifications`,
      count: notificationCount,
      icon: <Bell width={24} height={24} />,
    },
    {
      href: cartPath,
      count: cartCount,
      icon: <Cart width={24} height={24} />,
    },
  ];
};

export type IconType = {
  action?: string;
  href?: string;
  count?: number;
  visibleOnDesktop?: boolean;
  icon: React.JSX.Element;
};

export const iconDataForGuest = (
  cartCount: number | null,
  cartPath: string,
) => {
  return [
    {
      action: "OPEN_SEARCH_BAR",
      visibleOnDesktop: false,
      icon: <Search width={24} height={24} />,
    },
    {
      href: cartPath,
      count: cartCount,
      icon: <Cart width={24} height={24} />,
    },
  ];
};

export const otherUserIcon = {
  href: "/v4/mychatpage?seekerId=80730937&platform=seeker",
  count: 0,
  icon: <Message width={24} height={24} />,
};

export const showSearchBar = ["/", "/boost", "/prep", "/learn", "/network"];

export const hamburgerBanner = (mediaUrl: string | null) => [
  {
    name: "foundit",
    imageUrl: `//${mediaUrl}/public/core/images/downloadApp.webp`,
    link: "https://appurl.io/foundit",
  },
  {
    name: "skillyst",
    imageUrl: `//${mediaUrl}/public/core/images/skillyst.webp`,
    link: "/skillyst/",
  },
  {
    name: "zuno",
    imageUrl: `//${mediaUrl}/public/core/images/zuno.webp`,
    link: "/zuno/",
  },
];
